import React, { useRef, useState } from 'react';
import styled from 'styled-components';

export default function GanttChart({ selectedSimulator, selectedSimulatorData, setSelectedSimulatorData }) {
	const [year, setYear] = useState(2025);

	const months = [
		"Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
		"Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre",
	];

	const keyDates = [/* 
		{ position: 16.66, label: "Febrero" },
		{ position: 50, label: "Junio" },
	 */];

	const rowRef = useRef(null);
	const chartRef = useRef(null);

	const [hoveredPerson, setHoveredPerson] = useState(null);

	const handleMouseEnter = (person) => {
		setHoveredPerson(person);
	};

	const handleMouseLeave = () => {
		setHoveredPerson(null);
	};

	function fechaAIndice(fechaStr) {
		const fecha = new Date(fechaStr);

		const inicioAno = new Date(`2025-01-01T00:00:00`);
		const finAno = new Date(`2025-12-31T23:59:59`);

		return (fecha - inicioAno) / (finAno - inicioAno);
	}

	console.info("info to CHART", selectedSimulatorData)

	return (
		<Container>

			<Title>Año: {year}</Title>

			<MonthsGrid>
				{months.map((month, index) => (
					<Month key={index}>{month}</Month>
				))}
			</MonthsGrid>

			<ChartWrapper
				ref={chartRef}
			>
				{/* {keyDates.map((date, index) => (
					<KeyDateLine key={index} left={date.position} height={chartRef?.current?.scrollHeight} />
				))} */}

				<div>
					{selectedSimulator?.run_codes[0]?.users?.map((person, index) => {
						const personStart = fechaAIndice(person?.sessions?.[0]?.timestamp)
						const personEnd = fechaAIndice(person?.sessions?.[person?.sessions?.length - 1]?.timestamp)
						const startPercent = personStart * 100;
						const widthPercent = personStart === personEnd ? 0 : (personEnd - personStart) * 100;

						return (
							<GanttRow
								ref={rowRef}
								key={index}
								onMouseEnter={() => handleMouseEnter(person)}
								onMouseLeave={handleMouseLeave}
							>
								<GanttBar
									start={startPercent}
									width={widthPercent}
									userScore={person?.user_prom_score}
								>
									<span>
										{person?.sessions?.map((session, i) => {
											const relativeLeft = fechaAIndice(session?.timestamp) * 100
											return (
												<MilestoneDot
													key={i}
													left={relativeLeft}
													userScore={person?.user_prom_score}
													selectedMilestonDot={selectedSimulatorData?.msg_id === session?.msg_id && person?.user_name === selectedSimulatorData?.user_name}
													onClick={() => setSelectedSimulatorData({
														...session
													})}
												>
													{
														(
															!!hoveredPerson
															&& session?.msg_id === hoveredPerson?.sessions?.filter((filteredSession) => filteredSession?.msg_id === session?.msg_id)[0]?.id
															&& person.user_name === hoveredPerson.user_name
														) &&
														<label>
															{hoveredPerson?.sessions?.filter((filteredSession) => filteredSession?.msg_id === session?.msg_id)[0]?.score} pts
														</label>
													}
												</MilestoneDot>
											);
										})}
									</span>
								</GanttBar>
								<PersonName start={startPercent}>
									{person?.user_name}
									{
										!!hoveredPerson
										&& person?.user_name === hoveredPerson?.user_name && <label> - <i>Promedio general {person?.user_prom_score} puntos</i></label>
									}
								</PersonName>
							</GanttRow>
						);
					})}
				</div>
				<BottomDotsContainer>
					{keyDates.map((date, index) => (
						<KeyDateDot key={index} left={date.position} />
					))}
				</BottomDotsContainer>
			</ChartWrapper>
		</Container>
	);
}

const Container = styled.div`
	width: 100%;
	margin: 0;
	padding: 0 1rem;
	background-color: white;
`;

const Title = styled.h1`
	text-align: center;
	margin-bottom: 1rem;
	font-size: 1.25rem;
	font-weight: bold;
`;

const MonthsGrid = styled.div`
	width: 100%;
	display: grid;
	grid-template-columns: repeat(12, 1fr);
	margin-bottom: 1rem;
`;

const Month = styled.div`
	text-align: center;
	font-size: 0.875rem;
	font-weight: 500;
`;

const ChartWrapper = styled.div`
  	position: relative;
	height: 60vh;
	overflow-y: scroll;
	overflow-x: hidden;
`;

const KeyDateLine = styled.div`
	position: absolute;
	top: 0;
	bottom: 0;
	width: 1px;
	border-left: 1px dashed #d1d5db;
	z-index: 10;
	left: ${({ left }) => `${left}%`};
	height: ${({ height }) => `${height}px`};
`;

const GanttRow = styled.div`
	position: relative;
	margin-bottom: 3rem;
`;

const GanttBar = styled.div`
	height: 2.5rem;
	border-radius: 100px;
	background-color: ${({ userScore }) => userScore < 2 ? "#EE7872" : userScore < 4 ? "#35D0A5" : "#DBC68F"};
	margin-left: ${({ start }) => `calc(${start}% - 2rem)`};
	min-width: 65px;
	width: ${({ width }) => `calc(${width}% + 4rem)`};
	z-index: 11;
	display: flex;
	justify-content: center;
	align-items: center;
	&:hover {
		outline: 1px solid ${({ userScore }) => userScore < 2 ? "#CD2118" : userScore < 4 ? "#1E8065" : "#C29F43"};
	}

	span {
		width: 80%;
	}
`;

const MilestoneDot = styled.button`
	cursor: pointer;
	position: absolute;
	top: 50%;
	width: 2rem;
	height: 2rem;
	background-color: ${({ userScore, selectedMilestonDot }) => selectedMilestonDot ? userScore < 2 ? "#F7BEBB" : userScore < 4 ? "#C1F0E3" : "#E7DAB6" : "#fff"};
	border-radius: 12px;
	border: 2px solid ${({ userScore, selectedMilestonDot }) => selectedMilestonDot ? userScore < 2 ? "#CD2118" : userScore < 4 ? "#1E8065" : "#C29F43" : 'transparent'};
	transform: translate(-50%, -50%);
	left: ${({ left }) => `${left}%`};

	label {
		height: 32px;
		width: 80px;
		position: absolute;
		top: -2.6rem;
		left: 50%;
		transform: translateX(-50%);
		background-color: #fff;
		border-radius: 8px;
		border: 1px solid #dcdcdc;
		color: #616161;
		text-align: center;
		font-size: 14px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
`;

const PersonName = styled.div`
	position: absolute;
	top: 3rem;
	left: ${({ start }) => `calc(${start}% + 1rem)`};
	font-weight: 500;

	i {
		font-size: 13px;
		color: #1D1D18;
	}
`;

const KeyDateDot = styled.div`
	position: absolute;
	z-index: 10;
	width: 0.5rem;
	height: 0.5rem;
	background-color: #6b7280;
	border-radius: 9999px;
	bottom: 0;
	left: ${({ left }) => `calc(${left}% - 3px)`};
`;

const BottomDotsContainer = styled.div`
	position: relative;
	height: 2rem;
	margin-top: 4rem;
`;